module.exports = __webpack_public_path__ + "img/john-pro.0f53208a.jpg";